// src/components/NotificationToast.jsx
import React, { useEffect, useRef } from 'react';

const NotificationToast = ({ message, type = 'success', onClose }) => {
  const savedOnClose = useRef(onClose);

  useEffect(() => {
    savedOnClose.current = onClose;
  }, [onClose]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (savedOnClose.current) {
        savedOnClose.current();
      }
    }, 3000); // auto close after 3 seconds
    return () => clearTimeout(timer);
  }, [message]);

  const getBgColor = () => {
    switch (type) {
      case 'error': return 'var(--danger)';
      case 'warning': return 'var(--warning)';
      case 'info': return 'var(--info)';
      default: return 'var(--success)';
    }
  };

  return (
    <div 
      className="toast fade-in"
      style={{
        backgroundColor: getBgColor(),
        color: '#ffffff',
        padding: '0.875rem 1.5rem',
        borderRadius: 'var(--border-radius-md)',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        boxShadow: 'var(--shadow-lg)',
        pointerEvents: 'auto',
        fontSize: '0.875rem',
        fontWeight: '500',
        minWidth: '250px',
        justifyContent: 'space-between'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        {type === 'error' && (
          <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        )}
        {type === 'success' && (
          <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        )}
        {type === 'info' && (
          <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        )}
        <span>{message}</span>
      </div>
      <button 
        onClick={onClose} 
        style={{ 
          background: 'none', 
          border: 'none', 
          color: '#ffffff', 
          cursor: 'pointer', 
          fontSize: '1rem',
          fontWeight: 'bold',
          opacity: 0.8
        }}
        type="button"
      >
        &times;
      </button>
    </div>
  );
};

export default NotificationToast;
